import { getSalesCheckinBffEndPoint } from '@makemydeal/dr-sales-checkin-ui-utils';
import * as bridgeUserSelectors from '@makemydeal/dr-dash-store/selectors/bridgeUserSelectors';
import { getActiveDealCommonOrgId, getAvailableDealerships } from '@makemydeal/dr-sales-checkin-store';

export const additionalSelectors = {
    getDealershipURL: (state: any) => {
        const bridgeUserId = bridgeUserSelectors.getBridgeId(state);
        if (bridgeUserId) {
            const endPoint = `users/dealerships`;
            return getSalesCheckinBffEndPoint(endPoint);
        }
        return '';
    },
    getCommonOrgId: (state: any) => getActiveDealCommonOrgId(state),
    getAvailableDealerships: (state: any) => getAvailableDealerships(state)
};
